import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTransferOwnershipDocument.Find.IRequest;
type Response = Api.Core.ProductTransferOwnershipDocument.Find.IResponse;
type Headers = Api.Core.ProductTransferOwnershipDocument.Find.IHeaders;
const url = '/api/ProductManagement/ProductTransferOwnershipDocument/:documentId';
export default async function productTransferOwnershipDocumentFindApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
